import PlumValuesLoader from '@/assets/plum-values-loader-downsized.gif';
import { TDimensions } from '../Layout';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface IProps {
  className?: string;
  title?: string;
  description?: string;
  dimensions?: {
    headerDimensions: TDimensions;
    footerDimensions: TDimensions;
    pageHeaderDimensions: TDimensions;
    gap: number;
  };
}

const Loader = ({ className, title, description, dimensions }: IProps) => {
  const headerHeight = dimensions?.pageHeaderDimensions?.height ?? 0;

  return (
    <div
      className={twMerge(
        clsx({
          'flex flex-col items-center justify-center gap-4 h-full max-w-[450px] w-full mx-auto':
            true,
        }),
        className
      )}
      style={{
        marginTop:
          headerHeight > 0 && headerHeight < 400
            ? -(headerHeight + (dimensions?.gap ?? 0))
            : 0,
      }}
    >
      <img
        src={PlumValuesLoader}
        alt="plum values loader"
        height={56}
        width={56}
      />
      {title && (
        <h1 className="text-gray-700 font-chromatica text-[16px] md:text-xl font-bold text-center leading-[140%]">
          {title}
        </h1>
      )}
      {description && (
        <h3 className="text-mobile-text-hierarchy text-sm font-medium text-center leading-[140%]">
          {description}
        </h3>
      )}
    </div>
  );
};

export default Loader;
